// eslint-disable-next-line no-unused-vars
import type { AxiosRequestConfig } from 'axios'
import { createLegacyApi } from '@/api/MoeAuthAPIClientFactory'
const HTTP_CODES_FOR_REPEAT = [406, 401]
const REPEATED_HEADER = 'X-OEAMTC-Repeated'

export default function setupResponseInterceptor (axios) {
  axios.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      if (HTTP_CODES_FOR_REPEAT.includes(error.response.status) && error.config.headers[REPEATED_HEADER] == null) {
        console.warn(`Request failed with error code ${error.response.status}. Trying to obtain new ssoId...`)
        try {
          await createLegacyApi().legacyGetUser3() // this will refresh the ssoId cookie
          console.warn(`Obtaining new SSO-ID successful!`)
        } catch (e) {
          console.error(`Failed to obtain new SSO-ID!`, e)
        }
        console.warn('Repeating request...')
        const newConfig: AxiosRequestConfig = {
          ...error.config,
          headers: {
            ...error.config.headers,
            [REPEATED_HEADER]: 'true'
          }
        }
        return new Promise((resolve) => resolve(axios(newConfig)))
      } else {
        if (error.config.headers[REPEATED_HEADER]) {
          console.error(`Repeated request failed with error code ${error.response.status}`)
        }
        return Promise.reject(error)
      }
    }
  )
}
